import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "../../data/modal";
import TabView from "../partial/TabView";
import TerminalCallDetail from "../partial/TerminalCallDetail";
import ContainerCounts from "../partial/ContainerCounts";

import {
    Button,
    Divider,
    Grid,
} from "@mui/material";

import {
    Close as CloseIcon,
    Edit as EditIcon,
} from "@mui/icons-material";

const TerminalCallDetails = (properties: any, show: boolean) => {
    const dispatch = useDispatch();
    const terminalCall = properties.terminalCall;
    const containers = properties.containers;
    const containerTypes = properties.containerTypes;

    const filterContainerByIds = (containerIds) => {
        return containers.data.filter(
            (container) =>
                containerIds.includes(
                    container["@id"]
                )
                && container.position
        )
    }

    if (!terminalCall) {
        return
    }

    return (
        <Grid container>
            <TerminalCallDetail terminalCall={properties.terminalCall} />
            <Grid item className="planning-terminal-action" sx={{ width: '100% !important', margin: '5px 0 0 !important' }}>
                <ContainerCounts
                    containers={containers.data.filter(c => terminalCall.loadingContainers.some(container => container['@id'] === c['@id']))}
                    containerTypes={containerTypes.data}
                    loading={true}
                />
            </Grid>
            <Grid item className="planning-terminal-action" sx={{ width: '100% !important', margin: '5px 0 0 !important' }}>
                <ContainerCounts
                    containers={containers.data.filter(c => terminalCall.unloadingContainers.some(container => container['@id'] === c['@id']))}
                    containerTypes={containerTypes.data}
                    loading={false}
                />
            </Grid>
            <TabView views={[

            ]} />

            <Grid item xs={12} sm={12} marginTop={1} marginBottom={1}>
                <Divider orientation="horizontal" />
            </Grid>

            <Grid item xs={12} className='button-wrapper' sx={{ justifyContent: 'space-between' }}>
                <Button
                    onClick={() => { dispatch(hideModal()) }}
                    variant='contained'
                >
                    <CloseIcon fontSize="inherit" />&nbsp;Close
                </Button>
            </Grid>
        </Grid>
    );
}

export default TerminalCallDetails;
